<template>
  <div class="mt-lg-16">
    <v-container class="mt-16 pt-12">
      <div class="d-flex justify-center flex-column align-center">
        <v-icon class="primary--text text--lighten-1" size="80"
          >fas fa-check-circle</v-icon
        >
        <div
          class="text-lg-h2 text-md-h3 text-h4 text-center primary--text mt-3"
        >
          Sua mensagem foi enviada com sucesso!
        </div>
        <div class="open-sans mt-2 text-center">
          Agradecemos pelo contato, retornaremos em breve.
        </div>
        <v-btn
          to="/"
          rounded
          width="100px"
          color="secondary"
          class="mt-10 text-none open-sans font-weight-bold"
          ><v-icon size="13" class="mr-2">fas fa-undo</v-icon>Voltar</v-btn
        >
      </div>
      <div color="primary" class="d-flex justify-end mt-10 white--text"></div>
    </v-container>
  </div>
</template>

<script>
export default {
  computed: {
    informations() {
      return this.$rest(`informations`).item;
    },
  },
  mounted() {
    this.$rest(`informations`).get({
      save: (state, data) => (state.item = data),
    });
  },
  components: {},
};
</script>

<style></style>
